import React from "react";
import { Switch, Route } from "react-router-dom";
import { APP_CONFIG_ROUTES } from "../../../constants";
import { Layout } from "../../components";
import { P_Props } from "./MainApp.type";
import { Loading } from "../../components";
import { LoginForm } from "../../containers";

const MainAppPresenter: React.FC<P_Props> = (props) => {
  return (
    <>
      {props.loading ? (
        <Loading style={{ marginTop: "10rem" }} />
      ) : (
        <>
          {props.Auth.data?.token ? (
            <>
              {!props.Me.loading && props.Me.data?.email ? (
                <>
                  <Switch>
                    <Layout
                      user={props.userData}
                      routes={APP_CONFIG_ROUTES.filter((route) => {
                        const isValidModule = props.Me.data?.modules.includes(route.module);

                        return isValidModule;
                      })}
                      onLogout={props.onLogout}
                    >
                      {APP_CONFIG_ROUTES.map((route) => {
                        const isValidModule = props.Me.data?.modules.includes(route.module);

                        if (!isValidModule) {
                          return <React.Fragment key={route.path}></React.Fragment>;
                        }

                        const paths = [route.path, ...(route.withSubPaths || [])];
                        return (
                          <Route
                            key={route.path}
                            path={[...paths]}
                            exact
                            render={() => {
                              return route.renderComponent();
                            }}
                          />
                        );
                      })}
                    </Layout>
                  </Switch>
                </>
              ) : (
                <Loading style={{ marginTop: "10rem" }} />
              )}
            </>
          ) : (
            <>
              <LoginForm onSigninSuccess={props.onSigninSuccess} />
            </>
          )}
        </>
      )}

      {/* <Switch>
        <Layout
          routes={APP_CONFIG_ROUTES}
          onLogout={props.onLogout}
        >
          {APP_CONFIG_ROUTES.map((route) => {

            const paths = [route.path, ...(route.withSubPaths || [])];
            return (
              <Route
                key={route.path}
                path={[...paths]}
                exact
                render={() => {
                  return route.renderComponent();
                }}
              />
            );
          })} */}
      {/* <Redirect from="/" to={APP_ROUTES.INVENTORY.BASE} exact />
          <Redirect from="*" to={APP_CONFIG.FALLBACK_ROUTE} exact /> */}
      {/* </Layout>
      </Switch> */}
    </>
  );
};

export default MainAppPresenter;
